import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/anime";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-sparkling-2-fill text-xl leading-none" />
              </span>
              <span className="text-lg font-black tracking-tight text-background-50">妖精动漫</span>
            </div>
            <p className="mt-4 text-[13px] leading-6 text-primary-200 max-w-md">
              妖精动漫是面向国产、日韩动画爱好者的内容门户，集中呈现最新热门动漫信息、作品详情与行业资讯。站内播放入口为演示占位，不提供真实视频资源。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["国漫", "日漫", "韩漫改", "科幻", "奇幻", "治愈"].map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-full bg-primary-900 text-[11px] font-medium text-primary-200">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-[13px] font-semibold text-background-50 mb-4 tracking-wide">
              <Link to="/category/guoman" className="cursor-pointer hover:text-accent-400 transition-colors">动漫分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {categoryMeta.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-[13px] text-primary-200 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[13px] font-semibold text-background-50 mb-4 tracking-wide">
              <Link to="/news" className="cursor-pointer hover:text-accent-400 transition-colors">内容与帮助</Link>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/news" className="text-[13px] text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">动漫资讯</Link></li>
              <li><Link to="/search" className="text-[13px] text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">站内搜索</Link></li>
              <li><Link to="/about" className="text-[13px] text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-[13px] text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">使用说明</Link></li>
            </ul>
            <h4 className="text-[13px] font-semibold text-background-50 mt-6 mb-3 tracking-wide">合作联系</h4>
            <p className="text-[13px] text-primary-200 leading-6">
              partner@yaojing-anime.demo
              <br />
              周一至周五 10:00 – 18:00
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[12px] text-primary-300">
            © 2026 妖精动漫 · 本站为前端演示站点，所有作品与资讯内容均为示例数据
          </p>
          <div className="flex items-center gap-3 text-[12px] text-primary-300">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line" /> 内容演示
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-mouse-line" /> 桌面与移动端适配
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}